export default from './guest-registry-header-container'
